<template>
    <div class="page py-6 min-h-full">
        <slot/>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'Page',
})
</script>

<style scoped lang="scss">
.page {

}
</style>
